import { useHistory } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';

/**
 * Vrátí funkci pro bezpečný návrat na předchozí stránku.
 * `useLastLocation` vrací null, pokud v rámci aktuální session aplikace ještě neproběhla
 * žádná interní navigace (např. formulář byl otevřen jako první stránka, přímým odkazem
 * nebo v nové záložce) - v tom případě by history.goBack() odešel mimo aplikaci, proto se
 * místo toho přesměruje na fallbackPath.
 *
 * Pokud appka při přímém vstupu na stránku ještě neměla platnou session, projde se interně
 * přes /login a zpět (viz UnauthenticatedContent a Content.tsx) - to jsou reálné
 * history.push navigace, takže by je useLastLocation vykázal jako "předchozí stránku",
 * i když uživatel na login nikdy vědomě nenavigoval. Takové technické routy proto
 * nepovažujeme za platnou předchozí stránku.
 */
export const useSafeGoBack = (fallbackPath: string = '/home') => {
  const history = useHistory();
  const lastLocation = useLastLocation();
  const hasRealLastLocation = !!lastLocation && !lastLocation.pathname.includes('login');

  return () => {
    if (hasRealLastLocation) {
      history.goBack();
    } else {
      history.push(fallbackPath);
    }
  };
};

export default useSafeGoBack;
